import { getCookie } from '@express-labs/raven-tools';

const getImpactCookieData = () => {
  // CIQ-ID/ Impact SoCom seller cookie will be set by Adobe Launch
  // RULE = Direct Call Page Rule/Load Impact
  const ciqSharedID = getCookie('ciqSharedID');
  const irclickid = getCookie('irclickid');

  return { irclickid, ciqSharedID };
};

export default getImpactCookieData;
